import { render, staticRenderFns } from "./assignEvaluation.vue?vue&type=template&id=1f5f7518&"
import script from "./assignEvaluation.vue?vue&type=script&lang=js&"
export * from "./assignEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports